import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
  GroupItem,
  UserAdminGroupsInfo,
} from "../types/gruposResponsabilidade";

const EMPTY_GROUPS: GroupItem[] = [];

export function useAdminGroups() {
  const basicUserInfo = useSelector(
    (state: RootState) => state.user.basicUserInfo as UserAdminGroupsInfo | null,
  );
  const getUserStatus = useSelector(
    (state: RootState) => state.user.getUserStatus,
  );
  const userAdminGroups = basicUserInfo?.admin_groups;

  const adminGroups = Array.isArray(userAdminGroups)
    ? userAdminGroups
    : EMPTY_GROUPS;
  const isUserError = getUserStatus === "error" && !basicUserInfo;

  return {
    adminGroups,
    isGroupAdmin: adminGroups.length > 0,
    isUserError,
    isUserLoaded:
      getUserStatus === undefined
        ? !!basicUserInfo
        : getUserStatus === "ready" ||
          (getUserStatus === "error" && !!basicUserInfo) ||
          (getUserStatus === "idle" && !!basicUserInfo),
  };
}

export default useAdminGroups;
